import { ExcelColumn } from '../models/ExcelColumn';
import { utils } from 'xlsx';
import { ExcelWorksheet } from '../models/ExcelWorksheet';

function createRowConverter<TRow>(props: { columns: readonly ExcelColumn<TRow>[] }) {
  const { columns } = props;

  return (row: TRow, index: number, allRows: readonly TRow[]): Record<string, unknown> => {
    return columns.reduce(
      (acc: Record<string, unknown>, column: ExcelColumn<TRow>) => ({
        ...acc,
        [column.label]: column.accessor(row, index, allRows),
      }),
      {},
    );
  };
}

export function createWorksheet<TRow>(props: {
  name: string;
  rows: readonly TRow[];
  columns: readonly ExcelColumn<TRow>[];
}): ExcelWorksheet {
  const { name, rows, columns } = props;

  const convertRow = createRowConverter({
    columns,
  });

  const orderedHeaders = columns.map(({ label }: ExcelColumn<TRow>) => label);

  const convertedData = rows.map((row: TRow, index: number, allRows: readonly TRow[]) => {
    return convertRow(row, index, allRows);
  });

  return {
    name,
    orderedHeaders,
    data: convertedData,
    sheet: utils.json_to_sheet(convertedData, {
      header: orderedHeaders,
    }),
  };
}
